import type { AgentPlatformConnectionBase } from "@/api/useDeployments.types"

// The platform and the account or Entra tenant of one of its connections, as
// the deployments list names it
export const getCloudConnectionName = (
  platformName: string,
  connection: Pick<AgentPlatformConnectionBase, "connectionId">
) =>
  connection.connectionId
    ? `${platformName} (${connection.connectionId})`
    : platformName
